import { useRef as e, useImperativeHandle as o, useLayoutEffect as n } from "react";

function r({ref: r, opened: t, onCustomClose: c}) {
    const l = e(null), s = () => l.current?.open && l.current.close(), u = () => l.current?.open || l.current?.showModal(), p = c || s, a = c && (e => {
        e.preventDefault(), p();
    });
    return o(r, (() => ({
        close: s,
        softClose: p,
        open: u
    })), [ p ]), n((() => {
        "boolean" == typeof t && l.current && (t ? l.current.open || l.current.showModal() : l.current.open && l.current.close());
    }), [ t ]), "production" !== process.env.NODE_ENV && "boolean" == typeof t && r && console.warn("Modal: trying to use both opened prop and ref is uncommon"), 
    {
        innerRef: l,
        close: s,
        open: u,
        softClose: p,
        onCancelFinal: a
    };
}

export { r as default };
//# sourceMappingURL=index.js.map
